/* eslint-disable prefer-destructuring */
import {
    NAME_DOCUMENT_FOR_ROOM,
    NAME_DOCUMENT_FOR_USER,
    NAME_DOCUMENT_FOR_GAME_INFOR,
    ENUM_STATUS_GAME
} from "constants"

import React, { useEffect, useState } from "react"

import Equal from "containers/RoomDetail/Equal"
import GetShadow from "containers/RoomDetail/GetShadow"
import SetShadow from "containers/RoomDetail/SetShadow"
import Wait from "containers/RoomDetail/Wait"
import { useAppContext } from "contexts/AppProvider"
import { useGameInforContext } from "contexts/GameInforProvider"
import { subscribe, updateDocument, getDocument } from "firebase-helper/firestore-services"
import useEventListener from "hooks/useEventListener"
import { AiFillHome } from "react-icons/ai"
import { BsInfoCircleFill } from "react-icons/bs"
import { useNavigate, useParams } from "react-router-dom"
import { showNotification } from "utils"

export default function RoomDetail(){
    const { user, room, setRoom, gameInfor, setGameInfor } = useGameInforContext()
    const { setIsModalTutorialDisplayed, setIsLoading } = useAppContext()
    const navigate = useNavigate()

    const [hasAddUser, setHasAddUser] = useState(false)
    const [users, setUsers] = useState([])

    const { id } = useParams()

    const closeGame = async() => {
        const roomInfo = await getDocument(NAME_DOCUMENT_FOR_ROOM, id)
        const tempUsers = roomInfo.users.filter((u) => u !== user.id)
        await updateDocument(NAME_DOCUMENT_FOR_ROOM, id, {
            users: tempUsers
        })
        await updateDocument(NAME_DOCUMENT_FOR_GAME_INFOR, id, {
            status               : ENUM_STATUS_GAME.READY,
            shadow_user_is_ready : false,
            user_is_ready        : false
        })
    }

    const handleBackHome = async() => {
        await closeGame()
        navigate(`/`, { replace: true })
    }

    const cbGetRoomData = (data) => {
        setRoom({
            ...data,
            id
        })
    }

    const cbGetGameInforData = (data) => {
        setGameInfor({
            ...data,
            id
        })
    }

    useEventListener("beforeunload", (e) => {
        e.preventDefault()

        closeGame()
    })

    useEffect(() => {
        const addUserToRoom = async() => {
            if (!user?.id){
                return
            }

            setIsLoading(true)

            const roomInfo = await getDocument(NAME_DOCUMENT_FOR_ROOM, id)
            if (!roomInfo){
                showNotification(
                    "error",
                    "Phòng bạn yêu tìm không có , bạn yêu có thể tìm phòng mới :D"
                )
                handleBackHome()
            }
            if (roomInfo?.users.length === 0){
                updateDocument(NAME_DOCUMENT_FOR_ROOM, id, {
                    users: [user.id]
                })
            } else if (!roomInfo.users.some((userId) => userId === user.id)){
                if (roomInfo?.users.length >= 2){
                    showNotification(
                        "error",
                        "Phòng đang đủ 2 người , mời bạn yêu sang phòng khác nhé ^^"
                    )
                    handleBackHome()
                } else {
                    updateDocument(NAME_DOCUMENT_FOR_ROOM, id, {
                        users: [...roomInfo.users, user.id]
                    })
                }
            }
            setHasAddUser(true)

            setIsLoading(false)
        }

        addUserToRoom()
    }, [user])

    useEffect(() => {
        if (hasAddUser){
            subscribe(NAME_DOCUMENT_FOR_ROOM, id, cbGetRoomData)
            subscribe(NAME_DOCUMENT_FOR_GAME_INFOR, id, cbGetGameInforData)
        }
    }, [hasAddUser])

    useEffect(() => {
        const getUsers = async() => {
            if (!room || room?.users.length === 0){
                return
            }

            const tempUsers = []
            await Promise.all(
                room.users.map(async(userId) => {
                    const userInfo = await getDocument(NAME_DOCUMENT_FOR_USER, userId)
                    tempUsers.push({
                        ...userInfo,
                        id: userId
                    })
                })
            )

            setUsers(tempUsers)
        }

        getUsers()
    }, [room])

    const showContent = () => {
        if (gameInfor.status === ENUM_STATUS_GAME.READY){
            return <Wait room={ room } user={ user } users={ users } />
        }
        if (gameInfor.status === ENUM_STATUS_GAME.SET_SHADOW){
            return <SetShadow canSetShadow={ gameInfor.userid_set_shadow === user.id } roomId={ id } />
        }
        if (gameInfor.shadow_user_is_ready && gameInfor.user_is_ready){
            return (
                <Equal
                    infor={ gameInfor }
                    roomId={ id }
                    userId={ user.id }
                    users={ users }
                />
            )
        }
        if (gameInfor.status === ENUM_STATUS_GAME.GET_SHADOW){
            let tempSeri = gameInfor.series[0]
            if (
                (user.id === gameInfor.userid_set_shadow && !gameInfor.shadow.is_hand_left) ||
                (user.id !== gameInfor.userid_set_shadow && gameInfor.shadow.is_hand_left)
            ){
                tempSeri = gameInfor.series[1]
            }

            return (
                <GetShadow
                    isUserSetShadow={ gameInfor.userid_set_shadow === user.id }
                    roomId={ id }
                    seri={ tempSeri }
                    shadow={ gameInfor.shadow }
                />
            )
        }

        return <></>
    }

    return (
        <>
            { users.length > 0 && (
                <>
                    { showContent() }

                    <div
                        className="cursor-pointer fixed bottom-[90px] right-4 p-3 tablet:p-4 text-white bg-primary rounded-full flex-center"
                        onClick={ handleBackHome }
                    >
                        <AiFillHome size={ 24 } />
                    </div>

                    <div
                        className="cursor-pointer fixed bottom-[152px] right-4 p-3 tablet:p-4 text-white bg-quaternary rounded-full flex-center"
                        onClick={ () => setIsModalTutorialDisplayed(true) }
                    >
                        <BsInfoCircleFill size={ 24 } />
                    </div>
                </>
            ) }
        </>
    )
}
